module.exports = __webpack_public_path__ + "img/harga-special-gray.d6fe9e4a.svg";